require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("jquery")
require("toastr")
require("bootstrap")
require("@nathanvda/cocoon")

require("components/metisMenu.min")
require("components/nav")
require("components/button-checkbox")
require("components/c_selector-handler")
require("components/form")

import toastr from 'toastr'

window.toastr = toastr;

//= require_tree .
